import React from "react";
import { SideDialogsController } from "../types";

export const SideDialogsControllerContext = React.createContext<SideDialogsController>({} as SideDialogsController);
